const Footer = () => {
  return <footer id="avb-footer"></footer>;
};

export default Footer;
